module.exports = __webpack_public_path__ + "img/sticker-normal.583c9f58.svg";